import Header from "../Components/Header";
import "./Customers.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { API_BASE, FILE_BASE } from "../config";

const Customers = () => {
  const navigate = useNavigate();

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/Customer`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch customers");
        }

        return res.json();
      })
      .then((data) => {
        setCustomers(data);
      })
      .catch((err) => {
        console.error("Error fetching customers:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const openCustomerDetails = (customer) => {
    navigate(`/customer-details/${customer.id}`);
  };

  return (
    <div className="customers-page">
      <Header />

      <div className="customers-top">
        <div>
          <h1 className="customers-title">Customers</h1>

          <p className="customers-subtitle">
            Manage your customer relationships
          </p>
        </div>
      </div>

      <div className="customers-table-wrapper">
        <table className="customers-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Orders</th>
              <th>Location</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  Loading customers...
                </td>
              </tr>
            ) : customers.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No customers found
                </td>
              </tr>
            ) : (
              customers.map((item) => (
                <tr key={item.id}>
                  <td
                    className="customers-clickable customers-name"
                    onClick={() => openCustomerDetails(item)}
                  >
                    {item.name}
                  </td>

                  <td
                    className="customers-clickable"
                    onClick={() => openCustomerDetails(item)}
                  >
                    {item.phoneNumber}
                  </td>

                  <td
                    className="customers-clickable"
                    onClick={() => openCustomerDetails(item)}
                  >
                    {item.email}
                  </td>

                  <td
                    className="customers-clickable customers-orders"
                    onClick={() => openCustomerDetails(item)}
                  >
                    {item.totalOrders}
                  </td>

                  <td
                    className="customers-clickable"
                    onClick={() => openCustomerDetails(item)}
                  >
                    <div className="customers-location-box">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="18"
                        viewBox="0 -960 960 960"
                        width="18"
                        fill="#8c8c8c"
                      >
                        <path d="M480-96q-15 0-29-6t-25-17q-129-120-197.5-226T160-544q0-134 94-229t226-95q132 0 226 95t94 229q0 93-68.5 199T534-119q-11 11-25 17t-29 6Zm0-384q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Z" />
                      </svg>

                      <span>
                        {item.city}, {item.state}
                      </span>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Customers;